import * as t from 'ts-schema';
import { defineMessage } from 'magpie-lib/models';

const createGroupPayloadSchema = t.object({
  label: t.string,
  childNavItemId: t.string,
});

const renameGroupPayloadSchema = t.object({
  groupId: t.string,
  label: t.string,
});

const removeGroupPayloadSchema = t.object({
  groupId: t.string,
});

export enum PinnedItemsGroupAction {
  CREATE = 'CREATE',
  RENAME = 'RENAME',
  REMOVE = 'REMOVE',
}

const pinnedItemsGroupActionSchema = t.union(
  t.literal(PinnedItemsGroupAction.CREATE),
  t.literal(PinnedItemsGroupAction.RENAME),
  t.literal(PinnedItemsGroupAction.REMOVE)
);

const pinnedItemsGroupChanged = defineMessage({
  type: 'pinned-items-group-changed' as const,
  payloadSchema: t.object({
    action: pinnedItemsGroupActionSchema,
    success: t.boolean,
    label: t.string,
    failureReason: t.optional(t.string),
  }),
});

const createGroup = defineMessage({
  type: 'create-pinned-items-group' as const,
  payloadSchema: createGroupPayloadSchema,
  reply: pinnedItemsGroupChanged,
});

const renameGroup = defineMessage({
  type: 'rename-pinned-items-group' as const,
  payloadSchema: renameGroupPayloadSchema,
  reply: pinnedItemsGroupChanged,
});

const removeGroup = defineMessage({
  type: 'remove-pinned-items-group' as const,
  payloadSchema: removeGroupPayloadSchema,
  reply: pinnedItemsGroupChanged,
});

export const pinnedItemsApi = {
  createGroup,
  renameGroup,
  removeGroup,
  pinnedItemsGroupChanged,
};
